import { Injectable } from '@angular/core';

@Injectable()
export class ConfirmService {
    activate: (title: string, prompt: string, dataToChange?: any, confirmButtonText?: string, secondaryPrompt?: string) => Promise<{ confirmed: boolean; changedData?: any }>;
}
